/**
 * @fileoverview DELETE handler for the "/engagement/campaigns/campaign_alert_preferences_delete/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsCampaignAlertPreferencesDeleteCampaignIdCacheKeys } from "./constants";
import type {
  DeleteEngagementCampaignsCampaignAlertPreferencesDeleteCampaignIdProps,
  EngagementCampaignsCampaignAlertPreferencesDeleteCampaignIdResult,
} from "./types";

export const deleteEngagementCampaignsCampaignAlertPreferencesDeleteCampaignId = reactQueryMutationAdapter(
  engagementCampaignsCampaignAlertPreferencesDeleteCampaignIdCacheKeys,
  (
    props: DeleteEngagementCampaignsCampaignAlertPreferencesDeleteCampaignIdProps
  ): Promise<EngagementCampaignsCampaignAlertPreferencesDeleteCampaignIdResult> => {
    return fetch(`/engagement/campaigns/campaign_alert_preferences_delete/${props.campaignId}`, "DELETE", props);
  }
);
